import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabaseConfigError = (!supabaseUrl || !supabaseKey)
  ? `Missing ${!supabaseUrl ? 'REACT_APP_SUPABASE_URL' : ''}${!supabaseUrl && !supabaseKey ? ' and ' : ''}${!supabaseKey ? 'REACT_APP_SUPABASE_ANON_KEY' : ''} — set in Vercel → Project Settings → Environment Variables, then redeploy.`
  : null

export const supabase = supabaseConfigError
  ? null
  : createClient(supabaseUrl, supabaseKey)